/**
 * Reminders Tour Configuration
 * Introduces users to reminder management features
 */

import { TourDefinition } from './tour.types';

export const remindersTour: TourDefinition = {
  id: 'reminders-tour',
  name: 'Reminders',
  page: '/reminders',
  version: 5, // Added sentimentals section, fixed tooltip placement
  nextTourId: 'leaderboard-tour', // Chain to leaderboard tour
  steps: [
    {
      id: 'reminders-intro',
      targetSelector: '[data-tour="reminders-header"]',
      title: 'Your Reminders',
      description:
        'Stay organized with reminders! Set follow-ups for leads, tasks to complete, and important dates to remember. Reminders are automatically prioritized to keep actionable items at the top.',
      placement: 'bottom',
    },
    {
      id: 'sentimentals-section',
      targetSelector: '[data-tour="sentimentals-section"]',
      title: 'Sentimentals - Automated Messages',
      description:
        'Send automated birthday and holiday messages to your leads! Sentimentals helps you stay connected with personalized greetings that are scheduled and sent automatically.',
      placement: 'bottom',
    },
    {
      id: 'reminder-list',
      targetSelector: '[data-tour="reminder-list"]',
      title: 'Smart Reminder List',
      description:
        'Your reminders are sorted by priority: Pending and Notified reminders appear at the top for immediate attention, while Completed, Cancelled, and Overdue items are grouped below for reference.',
      placement: 'auto',
    },
    {
      id: 'reminder-status',
      targetSelector: '[data-tour="reminder-list"]',
      title: 'Understanding Reminder Status',
      description:
        'Each reminder has a status: Pending (upcoming), Notified (notification sent), Completed (done), Cancelled, or Overdue. This helps you prioritize your follow-ups effectively.',
      placement: 'auto',
    },
    {
      id: 'add-reminder',
      targetSelector: '[data-tour="add-reminder"]',
      title: 'Create Reminder',
      description:
        'Click here to set a new reminder. Link it to a lead, set the date and time, and choose how you want to be notified.',
      placement: 'left',
    },
    {
      id: 'reminder-filters',
      targetSelector: '[data-tour="reminder-filters"]',
      title: 'Filter by Status',
      description:
        'Filter by status (Pending, Notified, Completed, Cancelled, Overdue), date range, or linked lead to find specific reminders quickly.',
      placement: 'bottom',
    },
    {
      id: 'complete-reminder',
      targetSelector: '[data-tour="reminder-actions"]',
      title: 'Manage Your Reminders',
      description:
        'Mark reminders complete, reschedule them, or cancel if no longer needed. Completed items move to the lower section so your active reminders stay front and center.',
      placement: 'left',
    },
  ],
};
